import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export function TopBar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const clubId = location.pathname.match(/^\/club\/([^/]+)/)?.[1];
  const { logout } = useAuth();
  const navigate = useNavigate();

  const homeTo = clubId ? `/club/${clubId}` : "/clubs";

  async function handleLogout() {
    setOpen(false);
    await logout();
    navigate("/login");
  }

  return (
    <header className="sticky top-0 z-30 border-b border-chalk-200 bg-chalk-50/95 backdrop-blur">
      <div className="mx-auto flex h-14 max-w-md items-center justify-between px-5">
        <Link to={homeTo} className="flex items-center gap-2" onClick={() => setOpen(false)}>
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-turf-700 text-chalk-50">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" className="h-4 w-4">
              <path d="M6 21V4l12 5.5L6 15" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
          <span className="font-display text-lg font-semibold text-turf-900">ClubConnect</span>
        </Link>

        <button
          type="button"
          aria-label={open ? "Menü schließen" : "Menü öffnen"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-ink-900"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-6 w-6">
            {open ? (
              <path d="M6 6l12 12M18 6 6 18" strokeLinecap="round" strokeLinejoin="round" />
            ) : (
              <path d="M4 7h16M4 12h16M4 17h16" strokeLinecap="round" strokeLinejoin="round" />
            )}
          </svg>
        </button>
      </div>

      {open && (
        <>
          <button
            aria-label="Menü schließen"
            onClick={() => setOpen(false)}
            className="fixed inset-0 z-20 bg-ink-900/20"
          />
          <nav className="absolute inset-x-0 top-14 z-30 border-b border-chalk-200 bg-white shadow-lg">
            <ul className="mx-auto max-w-md divide-y divide-chalk-100 px-5 py-2">
              {clubId && (
                <MenuLink to={`/club/${clubId}`} onClick={() => setOpen(false)}>
                  Club-Startseite
                </MenuLink>
              )}
              <MenuLink to="/clubs" onClick={() => setOpen(false)}>
                {clubId ? "Anderen Club wählen" : "Club-Auswahl"}
              </MenuLink>
              {clubId && (
                <>
                  <MenuLink to={`/club/${clubId}/info`} onClick={() => setOpen(false)}>
                    Club-Infos
                  </MenuLink>
                  <MenuLink to={`/club/${clubId}/ballflug`} onClick={() => setOpen(false)}>
                    Ballflug-Analyse
                  </MenuLink>
                  <MenuLink to={`/club/${clubId}/melden`} onClick={() => setOpen(false)}>
                    Problem melden
                  </MenuLink>
                </>
              )}
              <li>
                <button
                  onClick={handleLogout}
                  className="flex w-full items-center py-3 text-left text-flag-600 font-medium"
                >
                  Abmelden
                </button>
              </li>
              <MenuLink to="/account/delete" onClick={() => setOpen(false)}>
                <span className="text-ink-400">Konto löschen</span>
              </MenuLink>
            </ul>
          </nav>
        </>
      )}
    </header>
  );
}

function MenuLink({ to, children, onClick }: { to: string; children: React.ReactNode; onClick: () => void }) {
  return (
    <li>
      <Link to={to} onClick={onClick} className="flex items-center py-3 text-ink-900">
        {children}
      </Link>
    </li>
  );
}
